import { employerHubApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

import {
  EmployerResponse,
  EmployerConfigurationStatus,
  EnableEmployersAdminSyncRequest,
  PayrollRequiredDataModel,
  AdminSyncResponse,
  EmployerAdminPlatformSummaryResponse,
} from 'src/types';

export const getEmployers = (companyId: string, schemeId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.get<EmployerResponse[]>(`/api/v1/companies/${companyId}/schemes/${schemeId}/employers`, config);

export const getPayrollEnabledEmployers = (companyId: string, schemeId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.get<EmployerResponse[]>(
    `/api/v1/companies/${companyId}/schemes/${schemeId}/payroll-enabled-employers`,
    config,
  );

export const getEmployerById = (companyId: string, employerId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.get<AdminSyncResponse>(`/api/v1/companies/${companyId}/employers/${employerId}`, config);

export const disableAdminSync = (companyId: string, employerId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.patch<void>(`/api/v1/companies/${companyId}/employers/${employerId}/disable-sync`, null, config);

export type EmployerListSearchParams = {
  schemeId?: string;
  adminSync?: boolean;
  employerConfigurationStatus?: EmployerConfigurationStatus;
};

export const getEmployerListSearch = (
  companyId: string,
  params: EmployerListSearchParams,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.get<EmployerResponse[]>(`/api/v1/companies/${companyId}/employers/search`, {
    ...config,
    params,
  });

export const getIsThirdPartyAdminPlatformPresent = (companyId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.get<boolean>(`/api/v1/companies/${companyId}/is-third-party-admin-platform-present`, config);

export const getEmployerAdminPlatformSummary = (companyId: string, config: AxiosRequestConfig = {}) =>
  employerHubApi.get<EmployerAdminPlatformSummaryResponse>(
    `/api/v1/companies/${companyId}/employers/admin-platform-summary`,
    config,
  );

export const bulkEnableAdminSync = (
  companyId: string,
  data: EnableEmployersAdminSyncRequest,
  config: AxiosRequestConfig = {},
) => employerHubApi.patch<void>(`/api/v1/companies/${companyId}/enable-admin-sync`, data, config);

export const setStatusForPayrollNotRequired = (
  companyId: string,
  employerId: string,
  data: PayrollRequiredDataModel,
  config: AxiosRequestConfig = {},
) =>
  employerHubApi.patch<void>(
    `/api/v1/companies/${companyId}/employers/${employerId}/set-employer-status-payroll-not-required`,
    data,
    config,
  );
